import React from "react";
import { toast } from "sonner";
import { Copy, Link2 } from "lucide-react";

export const personalLink = (code) => `${window.location.origin}/?ref=${code}`;

export function shareLink(platform, code) {
  const link = personalLink(code);
  const text = `Entra in lista su AFTERLIST con il mio link → ${link}`;
  if (platform === "copy" || platform === "instagram") {
    navigator.clipboard.writeText(link);
    toast.success(platform === "instagram" ? "Link copiato — incollalo in bio o nelle storie" : "Link copiato!");
    return;
  }
  const urls = {
    whatsapp: `https://wa.me/?text=${encodeURIComponent(text)}`,
    telegram: `https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent("Entra in lista su AFTERLIST")}`,
  };
  window.open(urls[platform], "_blank");
}

export default function MyLinkCard({ code, title = "IL MIO LINK LISTA" }) {
  const link = personalLink(code);
  return (
    <div className="card-dark p-6 border-neon relative overflow-hidden" data-testid="my-link-card">
      <div className="absolute -top-10 -right-10 w-40 h-40 bg-neon opacity-10 blur-3xl"/>
      <div className="label-mono text-neon mb-2 flex items-center gap-2"><Link2 className="w-3 h-3"/>{title}</div>
      <div className="font-display text-3xl text-neon text-glow-neon mb-3" data-testid="my-link-code">{code}</div>
      <div className="flex items-center gap-2 p-3 bg-black border border-neutral-800">
        <span className="font-mono text-xs text-neutral-300 truncate flex-1" data-testid="my-link-url">{link}</span>
        <button onClick={() => shareLink("copy", code)} className="text-neon hover:text-white" data-testid="my-link-copy"><Copy className="w-4 h-4"/></button>
      </div>
      <div className="grid grid-cols-3 gap-2 mt-4">
        <button onClick={() => shareLink("whatsapp", code)} className="btn-ghost !py-2 !px-2 text-[10px]" data-testid="my-link-wa">WHATSAPP</button>
        <button onClick={() => shareLink("telegram", code)} className="btn-ghost !py-2 !px-2 text-[10px]" data-testid="my-link-tg">TELEGRAM</button>
        <button onClick={() => shareLink("instagram", code)} className="btn-ghost !py-2 !px-2 text-[10px]" data-testid="my-link-ig">INSTAGRAM</button>
      </div>
      <p className="text-xs text-neutral-500 mt-4">Chi entra dal tuo link viene tracciato automaticamente: ogni persona messa in lista ti accredita punti.</p>
    </div>
  );
}
